import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import AllUsersStats from './AllUsersStats';
import AllUsersFilters from './AllUsersFilters';
import AllUsersTable from './AllUsersTable';
import "./AllUsers.css";

const AllUsers = () => {
    const location = useLocation();
    const [filters, setFilters] = useState(() => {
        const params = new URLSearchParams(location.search);
        let deviceFromUrl = params.get('deviceType');
        if (params.has('Android')) deviceFromUrl = 'A';
        else if (params.has('iOS')) deviceFromUrl = 'I';
        return {
            userId: "", age: "", gender: "", location: "",
            loginStatus: params.get('loginStatus') || "", createdDate: "", userDataFlag: params.get('userDataFlag') || "",
            deviceType: (deviceFromUrl && ['I', 'A'].includes(deviceFromUrl)) ? deviceFromUrl : "",
            dateFilterType: params.get('dateFilterType') || "createdDate"
        };
    });
    const [startDate, setStartDate] = useState(() => {
        const params = new URLSearchParams(location.search);
        return params.get('startDate') || "";
    });
    const [endDate, setEndDate] = useState(() => {
        const params = new URLSearchParams(location.search);
        return params.get('endDate') || "";
    });
    const [viewTitle, setViewTitle] = useState(() => {
        const params = new URLSearchParams(location.search);
        return params.get('viewTitle') || "All Users";
    });

    const [loading, setLoading] = useState(false);
    
    const handleFilterApply = React.useCallback(({ filters: newFilters, startDate: newStart, endDate: newEnd }) => {
        setFilters(newFilters);
        setStartDate(newStart);
        setEndDate(newEnd);
    }, []);

    const handleClear = React.useCallback(() => {
        setFilters({
            userId: "", age: "", gender: "", location: "",
            loginStatus: "", createdDate: "", userDataFlag: "", deviceType: "", dateFilterType: "createdDate"
        });
        setStartDate("");
        setEndDate("");
        setViewTitle("All Users");
    }, []);

    return (
        <div className="all-users-wrapper">
            <div className="modern-header custom-mb-06">
                <div className="header-content">
                    <h1 className="header-title">{viewTitle}</h1>
                    <p className="header-subtitle">Comprehensive directory and analytics for platform members</p>
                </div>
            </div>

             {/* 2. Filters Section */}
            <AllUsersFilters 
                initialFilters={filters} 
                initialStartDate={startDate}
                initialEndDate={endDate}
                onApply={handleFilterApply} 
                onClear={handleClear}
                loading={loading}
            />

            {/* 1. Summary Stats & Charts */}
            <AllUsersStats filters={filters} startDate={startDate} endDate={endDate} />
            
           

            {/* 3. Users Table */}
            <AllUsersTable 
                filters={filters} 
                startDate={startDate} 
                endDate={endDate} 
                onLoadingChange={setLoading}
            />
        </div>
    );
};

export default AllUsers;
